import React, { useState, useRef, useEffect } from "react";
import { MdOutlineContentCopy } from "react-icons/md";
import { SlCheck } from "react-icons/sl";
import {
  FaSquareWhatsapp,
  FaSquareXTwitter,
  FaLinkedin,
} from "react-icons/fa6";
import { useStores } from "../../../store";
import Loader from "../../reusble_components/loader";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AiFillMail, AiOutlineCloseCircle } from "react-icons/ai";
import { getDomainForWhiteLabeling } from "../../../services/white_label";

const JobShare = ({
  isPopupVisible,
  handlePopUpVisible,
  onClose,
  link,
  loader,
  handleLoader,
  jobPost,
  emailBody,
  emailSubject,
  interview,
  typeOfCard,
}) => {
  const [selectedType, setSelectedType] = useState("jobSeeker");
  const [isCopied, setIsCopied] = useState(false);
  const popupRef = useRef();
  const { RecuiterStore, CommonStore } = useStores();
  const [searchParams] = useSearchParams();
  const isEdit = searchParams.get("isEdit");
  const id = searchParams.get("id");
  const jobPostLink = link?.jobPostLink;
  const clientLink = link?.clientLink;
  const navigate = useNavigate();
  const [timer, setTimer] = useState(300);

  // Get the actual job ID - prioritize URL parameter over store value
  const getJobId = () => {
    // If we have a URL parameter id (for editing), use that
    if (id) {
      return id;
    }
    // Otherwise use the store jobPostId (for newly created jobs)
    return RecuiterStore?.jobPostId;
  };

  // Construct links with proper job ID handling
  const getJobPostLink = () => {
    const jobId = getJobId();
    if (!jobId) {
      return "Job ID not available yet";
    }
    return getDomainForWhiteLabeling() === "app.reaidy.io"
      ? `https://reaidy.io/job/${jobId}`
      : `https://${getDomainForWhiteLabeling()}/jobpost/${jobId}`;
  };

  const getClientLink = () => {
    const jobId = getJobId();
    if (!jobId) {
      return "Job ID not available yet";
    }
    return `https://${getDomainForWhiteLabeling()}/share/job-applicants/${jobId}`;
  };

  // Use constructed links if the link prop doesn't provide them
  const finalJobPostLink = jobPostLink || getJobPostLink();
  const finalClientLink = clientLink || getClientLink();

  useEffect(() => {
    const interval = setInterval(() => {
      if (timer > 0) {
        setTimer(timer - 1);
      } else {
        clearInterval(interval);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [timer]);

  // Format timer to show minutes and seconds
  const formatTimer = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
  };

  const newEmialBody =
    emailBody ??
    `
    ${
      typeOfCard === "jobPostCard"
        ? `🔗 Job Link:  ${finalJobPostLink}
          
Step 1: Sign Up / Log In
Visit Reaidy.io and log in to your account.
If you're a new user, sign up using your email and complete the verification process.

Step 2: Find the Job Post
Click on the job link above or navigate to the Job Listings section.
Browse job details, including the job description, requirements, and assessment details.

Step 3: Apply for the Job
Click the "Apply Now" button on the job post.
Ensure your profile and resume are updated before applying.

Step 4: Take the Assessment
Once applied, proceed to the assessment section.
Follow the AI-driven interview process and complete the required test.
Your screen and camera will be recorded for evaluation purposes.

Step 5: Submission & Review
After completing the assessment, your responses will be evaluated by recruiters.
Track your application status in the dashboard.
If shortlisted, you will receive further communication from the recruiter.

📢 Need Help?
For any queries, reach out to connect@reaidy.io or call +91 8019933883
🚀 Good luck with your application!`
        : `
If you have received an interview link from Reaidy.io, follow these steps to complete your AI or manual interview successfully.
 
Interview link -> ${finalJobPostLink}
 
Step 1: Open the Interview Link
Click on the interview link provided to you. 
You will be directed to the interview login page.

Step 2: Log in or Sign Up
If you already have a Reaidy account, log in using your email and password.
If you are a new user, sign up using your email ID and set up your profile before proceeding.

Step 3: Review Interview Details
Once logged in, you will see interview instructions, job role details, and time limits.
Read the instructions carefully before starting.

Step 4: Check System Requirements
Ensure you have a stable internet connection (minimum 2 Mbps speed).
Use a laptop/desktop with a working camera and microphone.
The interview will record your screen and video for security.

Step 5: Start the Interview
Click on the "Start Interview" button.
If it's an AI interview, AI will generate and ask you questions based on the job role.
If it's a manual interview, pre-set questions from the recruiter will be displayed.

Step 6: Answer Questions
Speak clearly and answer the questions within the time limit.
If it is a coding assessment, type your answers in the provided editor.
The AI will evaluate your responses in real-time.

Step 7: Submit & Review
Once all questions are answered, click "Submit Interview".
Your interview report will be generated and shared with the recruiter.

Step 8: Next Steps
If you qualify, recruiters will contact you for the next round.
You can track your application status in your Reaidy dashboard.
Need help? Contact us at connect@reaidy.io or call +91 8019933883.
 
🚀 Good luck with your application!`
    }
  `;

  const emailSubjectText =
    (emailSubject ?? typeOfCard === "jobPostCard")
      ? "Step-by-Step Guide to Apply for a Job & Take Assessment on Reaidy.io 🚀"
      : "Steps to Attempt an Interview on Reaidy.io";

  const handleOverlayClick = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      if (onClose) {
        onClose();
      }
      handlePopUpVisible(false);
      if (interview) {
        let tab = "All";
        if (interview.includes("MCQ")) tab = "MCQs";
        else if (interview.includes("Interview")) tab = "Interviews";
        else if (interview === "Job Post") tab = "job posts";
        navigate(`/company/activity?button=${tab}`);
      }
    }
  };

  const data = [
    {
      id: 1,
      title: "MCQs",
      active: !CommonStore.label[2].skipped,
    },
    {
      id: 2,
      title: "Technical interview ",
      active: !CommonStore.label[3].skipped,
    },
    {
      id: 3,
      title: "HR interview",
      active: !CommonStore.label[4].skipped,
    },
    {
      id: 4,
      title: "Task",
      active: !CommonStore.label[5].skipped,
    },
  ];

  const handleLinkType = (type) => {
    setSelectedType(type);
  };

  const shareOnWhatsApp = () => {
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
      newEmialBody,
    )}`;
    window.open(whatsappUrl, "_blank");
  };

  const shareOnTwitter = () => {
    const twitterUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
      newEmialBody,
    )}`;
    window.open(twitterUrl, "_blank");
  };

  const shareOnEmail = () => {
    const emailSub = emailSubjectText;
    const email = `${newEmialBody} `;
    const emailUrl = `mailto:?subject=${encodeURIComponent(
      emailSub,
    )}&body=${encodeURIComponent(email)}`;
    window.open(emailUrl, "_blank");
  };

  const shareOnLinkedIn = () => {
    const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
      newEmialBody,
    )}`;
    window.open(linkedInUrl, "_blank");
  };

  // console.log(link);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(
      selectedType === "jobSeeker" ? finalJobPostLink : finalClientLink,
    );
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  return (
    <>
      <Loader loader={loader} text="Loading..." />
      <div className="">
        {isPopupVisible && (
          <div
            className="fixed inset-0 bg-black/30 backdrop-blur-sm flex z-50 justify-center items-center"
            onClick={handleOverlayClick}
          >
            <div
              ref={popupRef}
              className="bg-white rounded-xl relative w-[90%] max-w-lg shadow-2xl"
            >
              <div className="p-6">
                <AiOutlineCloseCircle
                  className="absolute right-4 top-4 text-gray-400 hover:text-gray-600 cursor-pointer transition-colors"
                  onClick={() => {
                    handlePopUpVisible(false);
                    if (interview) {
                      let tab = "All";
                      if (interview.includes("MCQ")) tab = "MCQs";
                      else if (interview.includes("Interview"))
                        tab = "Interviews";
                      else if (interview === "Job Post") tab = "job posts";
                      navigate(`/company/activity?button=${tab}`);
                    }
                  }}
                />

                {interview && (
                  <div className="text-center mb-6">
                    <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
                      <SlCheck className="text-green-500 text-xl" />
                    </div>
                    <p className="text-lg font-medium text-gray-800">
                      Your {interview} {isEdit ? "Updated" : "Created"}{" "}
                      Successfully
                    </p>
                  </div>
                )}

                <h2 className="text-xl font-semibold text-gray-800 text-center mb-6">
                  Share details with
                </h2>

                <div className="flex justify-center gap-3 mb-8">
                  <button
                    className={`px-6 py-2.5 rounded-lg text-sm font-medium transition-all min-w-[120px] ${
                      selectedType === "jobSeeker"
                        ? "bg-primary text-white shadow-sm"
                        : "border border-gray-200 text-gray-600 hover:border-primary hover:text-primary"
                    }`}
                    onClick={() => handleLinkType("jobSeeker")}
                  >
                    Job seeker
                  </button>
                  <button
                    className={`px-6 py-2.5 rounded-lg text-sm font-medium transition-all min-w-[120px] ${
                      selectedType === "client"
                        ? "bg-primary text-white shadow-sm"
                        : "border border-gray-200 text-gray-600 hover:border-primary hover:text-primary"
                    }`}
                    onClick={() => handleLinkType("client")}
                  >
                    Client
                  </button>
                </div>

                {RecuiterStore.isRunningAutoPost && (
                  <div className="mb-8">
                    <div className="space-y-3">
                      <span className="text-sm font-medium text-gray-600 block mb-2">
                        Posting on other platforms. Please wait...{" "}
                        {formatTimer(timer)}
                      </span>
                    </div>
                  </div>
                )}

                {jobPost && (
                  <div className="mb-8">
                    <div className="space-y-3">
                      <span className="text-sm font-medium text-gray-600 block mb-2">
                        Added Assessment
                      </span>
                      {data
                        .filter((item) => item.active)
                        .map((item) => (
                          <div
                            key={item.id}
                            className="flex items-center justify-between bg-gray-50 rounded-lg p-3"
                          >
                            <span className="text-sm font-medium text-gray-700">
                              {item.title}
                            </span>
                          </div>
                        ))}
                    </div>
                  </div>
                )}

                {selectedType && (
                  <div className="space-y-6">
                    <div>
                      {jobPost && (
                        <span className="text-sm font-medium text-gray-600 block mb-2">
                          Link
                        </span>
                      )}
                      <div
                        className="flex items-center justify-between bg-gray-50 rounded-lg p-3 cursor-pointer hover:bg-gray-100 transition-colors h-[48px]"
                        onClick={handleCopyLink}
                      >
                        <span className="text-sm text-gray-600 truncate mr-3 max-w-[calc(100%-40px)]">
                          {selectedType === "jobSeeker"
                            ? finalJobPostLink
                            : finalClientLink}
                        </span>
                        {isCopied ? (
                          <SlCheck className="text-green-500 text-lg transition-colors flex-shrink-0" />
                        ) : (
                          <MdOutlineContentCopy className="text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0" />
                        )}
                      </div>
                    </div>

                    <div className="text-center">
                      <h3 className="text-sm font-medium text-gray-600 mb-4">
                        Share the link with
                      </h3>
                      <div className="flex justify-center gap-4">
                        <FaSquareWhatsapp
                          className="text-2xl text-green-500 hover:text-green-600 cursor-pointer transition-colors"
                          onClick={shareOnWhatsApp}
                        />
                        <FaSquareXTwitter
                          className="text-2xl text-gray-700 hover:text-gray-900 cursor-pointer transition-colors"
                          onClick={shareOnTwitter}
                        />
                        <AiFillMail
                          className="text-2xl text-blue-500 hover:text-blue-600 cursor-pointer transition-colors"
                          onClick={shareOnEmail}
                        />
                        <FaLinkedin
                          className="text-2xl text-blue-600 hover:text-blue-700 cursor-pointer transition-colors"
                          onClick={shareOnLinkedIn}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default JobShare;
